"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _ref;

var _default = new _immutable.Record((_ref = {}, (0, _defineProperty2.default)(_ref, _constants.ADMIN_EMAIL_ADDRESS, null), (0, _defineProperty2.default)(_ref, _constants.APP_STYLE, null), (0, _defineProperty2.default)(_ref, _constants.DOMAIN, null), (0, _defineProperty2.default)(_ref, _constants.EMPTY, null), (0, _defineProperty2.default)(_ref, _constants.FORM_CAPTURE_ENABLED, null), (0, _defineProperty2.default)(_ref, _constants.POPUP_SUGGESTED_COLORS, null), (0, _defineProperty2.default)(_ref, _constants.PORTAL_CREATION_UTC, null), (0, _defineProperty2.default)(_ref, _constants.PORTAL_TIMEZONE_NAME, null), (0, _defineProperty2.default)(_ref, _constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST, (0, _immutable.List)()), (0, _defineProperty2.default)(_ref, _constants.SITE_NAME, null), _ref), _constants.MARKETING_FREE_SETTINGS);

exports.default = _default;
module.exports = exports.default;